import { DatasetEnvironmentRegistry } from './DatasetEnvironmentRegistry';

let registry: DatasetEnvironmentRegistry | undefined;

/** The one registry of the app. The first call creates it. */
export const getDatasetEnvironmentRegistry = (): DatasetEnvironmentRegistry => {
    registry ??= new DatasetEnvironmentRegistry();
    return registry;
};
